/* eslint-disable no-console */

async function unregisterServiceWorkers() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(
      registrations.map((registration) => registration.unregister())
    );

    if (registrations.length > 0) {
      console.log('Existing service worker registrations have been removed.');
    }
  } catch (error) {
    console.error('Error while removing service workers:', error);
  }
}

if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    unregisterServiceWorkers();
  });
}
